import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import assign from 'lodash/assign';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import pick from 'lodash/pick';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import map from 'lodash/map';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import isFunction from 'lodash/isFunction';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import startCase from 'lodash/startCase';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import debounce from 'lodash/debounce';
import Numeral from 'numeral';
import classNames from 'classnames';

import nds from '@nerdwallet/base-styles/classes';
import { InputGroup, RadioGroup, Text, Box } from '@nerdwallet/currency';
import { NumStepper } from '@nerdwallet/react-stepper';
import { Num as num, Tracking } from '@nerdwallet/nw-client-lib';

function preformatPercentage(value) {
  if (value.trim().endsWith('%')) {
    return value;
  }
  const number = new Numeral(value);
  return number.value() / 100;
}

// This is especially helpful for the slider.
const debouncedFormInputChange = debounce(Tracking.formInputChanged, 400);

class Calculator extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(name) {
    return (e) => {
      let value = e;
      if (e.target) {
        value = e.target.value;
      }
      this.props.onChange(name, value);
      debouncedFormInputChange({
        fieldName: name,
        fieldValue: String(value),
        formName: this.props.formName,
      });
    };
  }

  renderStepper(config) {
    const propNames = [
      'stepSize',
      'min',
      'max',
      'formatter',
      'editable',
      'preformatValue',
      'updateOnEnter',
    ];
    let value = null;
    if (config.inputs) {
      value = config.inputs[config.name];
    }
    let props = {
      value: num.value(value),
    };

    props.onChange = this.onChange(config.name);

    const formatFn = isFunction(config.formatFn)
      ? config.formatFn
      : config.formatType &&
        ((val) => num[`format${startCase(config.formatType)}`](val));
    props = assign(props, {
      ...pick(config, propNames),
      formatFn,
    });
    return (
      <InputGroup
        label={(config.label || '').toUpperCase()}
        tooltip={config.help}
        input={<NumStepper {...props} />}
        inputId={`stepper-${config.label}`}
      />
    );
  }

  renderRadioArray(config) {
    const value = config.inputs[config.name];
    return (
      <RadioGroup
        inline={this.props.size !== 'sm'}
        name={config.name}
        value={value}
        options={map(config.values, (valueOption) => ({
          label: valueOption.label,
          value: valueOption.value,
        }))}
        onChange={this.onChange(config.name)}
      />
    );
  }

  renderSlider(config) {
    return (
      <Box>
        <Box>
          <Slider
            min={config.min}
            max={config.max}
            value={config.inputs[config.name]}
            onChange={this.onChange(config.name)}
          />
        </Box>
        <Box className={nds('margin-top-2')}>
          <Text bold>{config.inputs[config.name]} years</Text>
        </Box>
      </Box>
    );
  }

  renderTimespan() {
    return (
      <Box>
        <Box>
          {this.renderSlider({
            name: 'investment_timespan',
            subType: 'number',
            stepSize: 1,
            min: 1,
            max: 50,
            inputs: this.props.data.resolvedInputs,
          })}
        </Box>
      </Box>
    );
  }

  render() {
    return (
      <Fragment>
        <Box
          className={classNames([nds('margin-bottom-4'), nds('margin-top-2')])}
        >
          {this.renderStepper({
            label: 'Initial Deposit',
            name: 'initial_principal',
            subType: 'number',
            stepSize: 100,
            min: 100,
            max: 1000000,
            formatType: 'currency',
            editable: true,
            formatter: '$0',
            updateOnEnter: true,
            inputs: this.props.data.resolvedInputs,
          })}
        </Box>
        <Box className={nds('margin-bottom-2')}>
          {this.renderStepper({
            label: 'Contributions',
            name: 'contribution_amount',
            subType: 'number',
            stepSize: 50,
            max: 10000,
            min: 0,
            formatType: 'currency',
            editable: true,
            formatter: '$0',
            updateOnEnter: true,
            inputs: this.props.data.resolvedInputs,
          })}
        </Box>
        <Box className={nds('margin-bottom-4')}>
          {this.renderRadioArray({
            name: 'contribution_period',
            values: [
              {
                label: 'monthly',
                value: 'monthly',
              },
              {
                label: 'annually',
                value: 'annually',
              },
            ],
            inputs: this.props.data.resolvedInputs,
          })}
        </Box>
        <Box className={nds('margin-bottom-4')}>
          <InputGroup
            label="INVESTMENT TIME SPAN"
            input={this.renderTimespan()}
            inputId="investmentTimespan"
          />
        </Box>
        <Box className={nds('margin-bottom-4')}>
          {this.renderStepper({
            label: 'Estimated Rate of Return',
            name: 'percent_return',
            subType: 'number',
            stepSize: 0.0025,
            min: 0,
            max: 0.5,
            formatType: 'percent',
            editable: true,
            formatter: '0.00%',
            preformatValue: preformatPercentage,
            updateOnEnter: true,
            inputs: this.props.data.resolvedInputs,
          })}
        </Box>
        <Box>
          <InputGroup
            label="COMPOUND FREQUENCY"
            inputId="compoundFrequency"
            input={this.renderRadioArray({
              name: 'compounding_period',
              values: [
                {
                  label: 'monthly',
                  value: 'monthly',
                },
                {
                  label: 'annually',
                  value: 'annually',
                },
              ],
              inputs: this.props.data.resolvedInputs,
            })}
          />
        </Box>
      </Fragment>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Calculator.displayName = 'Calculator';
// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Calculator.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  formName: PropTypes.string,
  size: PropTypes.string,
};

export default Calculator;
